module.exports = __webpack_public_path__ + "img/icon_i.150c69b3.png";